import { Directive, Input, ElementRef, HostListener, Renderer2, OnDestroy } from '@angular/core';

@Directive({
  selector: '[tooltip]'
})
export class TooltipDirective implements OnDestroy{
  @Input('tooltip') tooltipTitle = '';
  @Input() placement = 'top';
  @Input() showOnFocus = true;
  @Input() delay: string;
  tooltip: HTMLElement | null = null;
  offset = 10;

  constructor(private el: ElementRef, private renderer: Renderer2) {
    this.delay = '500';
  }

  @HostListener('mouseenter') onMouseEnter() {
    if (!this.tooltip) { this.show(); }
  }

  @HostListener('focusin') onFocusIn() {
    if (!this.showOnFocus) {
      return;
    }
    if (!this.tooltip) { this.show(); }
  }

  @HostListener('mouseleave') onMouseLeave() {
    if (this.tooltip) { this.hide(); }
  }

  @HostListener('focusout') onFocusOut() {
    if (!this.showOnFocus) {
      return;
    }
    if (this.tooltip) { this.hide(); }
  }

  @HostListener('click') onClick() {
    if (this.tooltip) { this.hide(); }
  }

  show() {
    if (!this.tooltipTitle) {
      return;
    }
    this.create();
    this.setPosition();
  }

  hide() {
    if (this.tooltip) {
      this.renderer.removeClass(this.tooltip, 'ng-tooltip-show');
      window.setTimeout(() => {
        if (this.tooltip) {
          this.renderer.removeChild(document.body, this.tooltip);
          this.tooltip = null;
        }
      });
    }
  }

  create() {
    this.tooltip = this.renderer.createElement('span');
    const tooltipEl = this.tooltip;
    if (!tooltipEl) {
      return;
    }

    // Replace &#10; with <br> for line breaks and set as innerHTML
    const formattedText = this.tooltipTitle.replace(/&#10;/g, '<br>');
    tooltipEl.innerHTML = formattedText;

    this.renderer.appendChild(document.body, tooltipEl);
    this.renderer.addClass(tooltipEl, 'ng-tooltip');
    this.renderer.addClass(tooltipEl, `ng-tooltip-${this.placement}`);

    this.renderer.setStyle(tooltipEl, '-webkit-transition', `opacity ${this.delay}ms`);
    this.renderer.setStyle(tooltipEl, '-moz-transition', `opacity ${this.delay}ms`);
    this.renderer.setStyle(tooltipEl, '-o-transition', `opacity ${this.delay}ms`);
    this.renderer.setStyle(tooltipEl, 'transition', `opacity ${this.delay}ms`);
  }

  setPosition() {
    const tooltipEl = this.tooltip;
    if (!tooltipEl) {
      return;
    }
    const hostPos = this.el.nativeElement.getBoundingClientRect();
    const tooltipPos = tooltipEl.getBoundingClientRect();
    const scrollPos = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

    let top; let left;

    if (this.tooltipTitle) {
      this.renderer.addClass(tooltipEl, 'ng-tooltip-show');
      switch (this.placement) {
        case 'top':
          top = hostPos.top - tooltipPos.height - this.offset;
          left = hostPos.left + (hostPos.width - tooltipPos.width) / 2;
          break;
        case 'bottom':
          top = hostPos.bottom + this.offset;
          left = hostPos.left + (hostPos.width - tooltipPos.width) / 2;
          break;
        case 'left':
          top = hostPos.top + (hostPos.height - tooltipPos.height) / 2;
          left = hostPos.left - tooltipPos.width - this.offset;
          break;
        case 'right':
          top = hostPos.top + (hostPos.height - tooltipPos.height) / 2;
          left = hostPos.right + this.offset;
          break;
        default:
          break;
      }
      this.renderer.setStyle(this.tooltip, 'top', `${top + scrollPos}px`);
      this.renderer.setStyle(this.tooltip, 'left', `${left}px`);
    }
  }

  ngOnDestroy() {
    if (this.tooltip) {
      this.renderer.removeChild(document.body, this.tooltip);
      this.tooltip = null;
    }
  }
}
